import { customEvent } from "goi_common";

import { GOI_TRUST, MUBINSO_REVIEWS } from "@/constants/goiTrust";
import { ChevronRightIcon } from "@/components/DirectionsIcons";

const STATS = [
  { label: GOI_TRUST.consultLabel, value: GOI_TRUST.consultValue, suffix: "" },
  { label: GOI_TRUST.scoreLabel, value: GOI_TRUST.scoreValue, suffix: "점" },
  { label: GOI_TRUST.funeralLabel, value: GOI_TRUST.funeralValue, suffix: "" },
];

interface MubinsoTrustProps {
  parlorId: number;
  /** B 는 제목을 바꾸고 소개 문단을 뺀다 */
  variant?: "A" | "B";
}

/**
 * 후기는 4건 중 2건만, 장례식장 id 로 골라 보여준다. 4건을 전 페이지에 똑같이 두면
 * 1,022개 페이지가 같은 문단을 갖게 되어 템플릿 중복으로 묶이는 원인이 된다.
 * 연속한 2건을 고르므로 조합은 4가지이고, 같은 페이지는 항상 같은 후기를 보여준다.
 */
const pickReviews = (parlorId: number) => {
  const start = parlorId % MUBINSO_REVIEWS.length;
  return [0, 1].map(
    (offset) => MUBINSO_REVIEWS[(start + offset) % MUBINSO_REVIEWS.length]
  );
};

export const MubinsoTrust = ({
  parlorId,
  variant = "A",
}: MubinsoTrustProps) => {
  const isB = variant === "B";
  return (
    <section className="mb-trust" aria-labelledby="mb-trust-title">
      <div className="mb-trust__head">
        <h2 id="mb-trust-title" className="mb-trust__title">
          {isB
            ? "고이 무빈소장을 이용한 가족 후기"
            : "무빈소 장례로 진행하신 가족분들의 후기"}
        </h2>
        {!isB && (
          <p className="mb-trust__lede">
            고이장례연구소를 통해 무빈소 장례를 진행하신 분들의 솔직한 후기들을
            담았습니다. 형식을 줄인 것이 마음을 줄인 것은 아니며 불필요한
            추가금은 없었다고 말씀해 주셨습니다.
          </p>
        )}
      </div>

      <dl className="mb-trust__stats">
        {STATS.map((stat) => (
          <div key={stat.label} className="mb-trust__stat">
            <dd>
              {stat.value}
              {stat.suffix && (
                <span className="mb-trust__suffix">{stat.suffix}</span>
              )}
            </dd>
            <dt>{stat.label}</dt>
          </div>
        ))}
      </dl>

      <ul className="mb-reviews">
        {pickReviews(parlorId).map((review) => (
          <li key={review.id}>
            <a
              className="mb-review"
              href={`${process.env.NEXT_PUBLIC_PLATFORM_WEB_URL}/review/${review.id}/?utm_source=parlor_goi&utm_campaign=mubinso&utm_content=review`}
              target="_blank"
              rel="noreferrer noopener"
              onClick={() =>
                customEvent({
                  newGtm: {
                    path: "prlr_mubinso",
                    trigger_and_target: "btn_review",
                    properties: { parlor_id: parlorId, review_id: review.id },
                  },
                })
              }
            >
              <span
                className="mb-review__stars"
                aria-label={`${review.score}점`}
              >
                {"★".repeat(review.score)}
              </span>
              <blockquote>{review.text}</blockquote>
              <span className="mb-review__foot">
                <span>{`${review.author}, ${review.date} 작성`}</span>
                <span className="mb-review__more">
                  후기 전문 보기
                  <ChevronRightIcon size={14} />
                </span>
              </span>
            </a>
          </li>
        ))}
      </ul>

      <p className="mb-trust__note">{`*${GOI_TRUST.note}`}</p>
    </section>
  );
};
